import "./App.scss";
import QuickTabs from "./quicktabs";
import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FAQ from "./faq";
import TripDescription from "./trip_description";
import AboutHosts from "./about_hosts";
import Itinerary from "./itinerary";
import Pricing from "./pricing";
import Overview from "./overview";
import Hero from "./hero";
import FooterHero from "./footer_hero";
import Lodging from "./lodging";
import Gear from "./gear";

function App() {
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState();

  const getData = () => {
    fetch("data/app.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json_data) {
        setLoaded(true);
        setData(json_data);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div id="christmas-spa">
      <Container>
        {/* {loaded && (
        // <Container fluid>
          <Hero data={data.hero_page}></Hero>
        // </Container>
      )} */}
        {loaded && (
          <>
            <TripDescription data={data.trip_description_page} />
            <AboutHosts data={data.about_host} />
            <Overview data={data.overview} />
            <Itinerary data={data.itinerary} />
            <Lodging data={data.lodging} />
            <Pricing data={data.pricing} />
            {/* <QuickTabs data={data.quickTabs} /> */}
            <Gear data={data.gear} />

          </>
        )}
        {/* <Pricing /> */}
        <FAQ />
        {loaded && <FooterHero data={data.footer_hero}> </FooterHero>}
      </Container>
      <br />
      <br />
      <br />

      <br />
    </div>
  );
}

export default App;
